(function(){
  'use strict';

  // ───────── REVEAL ON SCROLL ─────────
  var reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    reveals.forEach(function(el){ observer.observe(el); });
  } else {
    reveals.forEach(function(el){ el.classList.add('visible'); });
  }

  // ───────── SMOOTH SCROLL ─────────
  document.querySelectorAll('a[href^="#"]').forEach(function(link){
    // Skip the moon trigger — it has its own click handler
    if (link.id === 'moon-trigger') return;
    link.addEventListener('click', function(e){
      var id = link.getAttribute('href');
      if (id.length <= 1) return;
      var target = document.querySelector(id);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  // ───────── EASTER EGG: JUMPER FLY-ACROSS ─────────
  var moonTrigger = document.getElementById('moon-trigger');
  var jumper = document.getElementById('jumper');
  var isFlying = false;
  var audioCtx = null;

  // Lazily create AudioContext (browsers require user gesture before audio)
  function getAudioCtx() {
    if (!audioCtx) {
      var Ctx = window.AudioContext || window.webkitAudioContext;
      if (Ctx) audioCtx = new Ctx();
    }
    return audioCtx;
  }

  // Whoosh: filtered noise that sweeps in pitch/volume
  function playWhoosh() {
    var ctx = getAudioCtx();
    if (!ctx) return;
    var now = ctx.currentTime;
    var duration = 1.4;

    // Generate white noise buffer
    var bufferSize = Math.floor(ctx.sampleRate * duration);
    var buffer = ctx.createBuffer(1, bufferSize, ctx.sampleRate);
    var data = buffer.getChannelData(0);
    for (var i = 0; i < bufferSize; i++) {
      data[i] = (Math.random() * 2 - 1) * 0.5;
    }

    var source = ctx.createBufferSource();
    source.buffer = buffer;

    // Bandpass filter sweep — gives the "whoosh by" feel
    var filter = ctx.createBiquadFilter();
    filter.type = 'bandpass';
    filter.Q.value = 1.2;
    filter.frequency.setValueAtTime(200, now);
    filter.frequency.exponentialRampToValueAtTime(1800, now + 0.5);
    filter.frequency.exponentialRampToValueAtTime(400, now + duration);

    // Volume envelope — rise, sustain, fall (mimics doppler pass-by)
    var gain = ctx.createGain();
    gain.gain.setValueAtTime(0, now);
    gain.gain.linearRampToValueAtTime(0.35, now + 0.3);
    gain.gain.linearRampToValueAtTime(0.4, now + 0.7);
    gain.gain.exponentialRampToValueAtTime(0.001, now + duration);

    source.connect(filter);
    filter.connect(gain);
    gain.connect(ctx.destination);
    source.start(now);
    source.stop(now + duration);
  }

  // Splash: low thump + high noise burst (water break + spray)
  function playSplash() {
    var ctx = getAudioCtx();
    if (!ctx) return;
    var now = ctx.currentTime;

    // ── Low thump (the body hitting water)
    var thump = ctx.createOscillator();
    thump.type = 'sine';
    thump.frequency.setValueAtTime(120, now);
    thump.frequency.exponentialRampToValueAtTime(40, now + 0.2);
    var thumpGain = ctx.createGain();
    thumpGain.gain.setValueAtTime(0.5, now);
    thumpGain.gain.exponentialRampToValueAtTime(0.001, now + 0.25);
    thump.connect(thumpGain);
    thumpGain.connect(ctx.destination);
    thump.start(now);
    thump.stop(now + 0.3);

    // ── Splash noise (water spray / droplets)
    var splashDur = 0.6;
    var bufSize = Math.floor(ctx.sampleRate * splashDur);
    var buf = ctx.createBuffer(1, bufSize, ctx.sampleRate);
    var d = buf.getChannelData(0);
    for (var i = 0; i < bufSize; i++) {
      d[i] = (Math.random() * 2 - 1);
    }

    var splash = ctx.createBufferSource();
    splash.buffer = buf;

    // Highpass to give it that splashy "wet" quality
    var hp = ctx.createBiquadFilter();
    hp.type = 'highpass';
    hp.frequency.setValueAtTime(1200, now);
    hp.frequency.exponentialRampToValueAtTime(400, now + splashDur);

    var splashGain = ctx.createGain();
    splashGain.gain.setValueAtTime(0, now);
    splashGain.gain.linearRampToValueAtTime(0.4, now + 0.02);
    splashGain.gain.exponentialRampToValueAtTime(0.001, now + splashDur);

    splash.connect(hp);
    hp.connect(splashGain);
    splashGain.connect(ctx.destination);
    splash.start(now);
    splash.stop(now + splashDur);
  }

  function flyJumper() {
    if (isFlying || !jumper) return;
    isFlying = true;

    // Resume audio context if suspended (Safari/iOS requirement)
    var ctx = getAudioCtx();
    if (ctx && ctx.state === 'suspended') {
      ctx.resume();
    }

    // Whoosh starts immediately as the figure enters
    playWhoosh();

    // Trigger animation
    jumper.classList.add('flying');

    // Splash ~1.5s in, just before he exits the left edge (animation is 1.8s total)
    setTimeout(playSplash, 1500);

    // Cleanup after animation completes
    setTimeout(function(){
      jumper.classList.remove('flying');
      isFlying = false;
    }, 1850);
  }

  if (moonTrigger) {
    moonTrigger.addEventListener('click', function(e){
      e.preventDefault();
      flyJumper();
    });
  }
})();

/* ───────── MAILCHIMP SUBSCRIBE + VAULT UNLOCK ───────── */
(function(){
  'use strict';

  var VAULT_VIDEO_ID = 'wKi0VE4fUoc';
  var STORAGE_KEY = 'me_vault_unlocked';

  var form = document.getElementById('mc-embedded-subscribe-form');
  var msg = document.getElementById('mc-form-msg');
  var btn = document.getElementById('mc-embedded-subscribe');
  var vault = document.getElementById('vault');
  var vaultBackdrop = document.getElementById('vault-backdrop');
  var vaultClose = document.getElementById('vault-close');
  var vaultVideo = vault ? vault.querySelector('.vault-video') : null;
  var vaultReturn = document.getElementById('vault-return');
  var navVault = document.getElementById('nav-vault');

  function isUnlocked() {
    try { return localStorage.getItem(STORAGE_KEY) === '1'; } catch (e) { return false; }
  }
  function setUnlocked() {
    try { localStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
    if (vaultReturn) vaultReturn.style.display = 'inline-block';
  }

  function openVault() {
    if (!vault || !vaultVideo) return;
    // Inject iframe only on open — keeps the exclusive off the page for non-subscribers
    vaultVideo.innerHTML = '<iframe src="https://www.youtube.com/embed/' + VAULT_VIDEO_ID +
      '?autoplay=1&rel=0&modestbranding=1" title="Midnight Era — Subscriber Exclusive" ' +
      'allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>';
    vault.hidden = false;
    document.body.classList.add('vault-locked');
    // Next frame so the transition runs
    requestAnimationFrame(function(){
      requestAnimationFrame(function(){ vault.classList.add('open'); });
    });
  }

  function closeVault() {
    if (!vault) return;
    vault.classList.remove('open');
    document.body.classList.remove('vault-locked');
    setTimeout(function(){
      vault.hidden = true;
      if (vaultVideo) vaultVideo.innerHTML = ''; // stop playback
    }, 500);
  }

  if (vaultBackdrop) vaultBackdrop.addEventListener('click', closeVault);
  if (vaultClose) vaultClose.addEventListener('click', closeVault);
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && vault && !vault.hidden) closeVault();
  });

  // Returning subscribers: show the rewatch link
  if (isUnlocked() && vaultReturn) vaultReturn.style.display = 'inline-block';
  if (vaultReturn) vaultReturn.addEventListener('click', openVault);

  // Header "Vault" link: open if unlocked, otherwise scroll to the form
  if (navVault) {
    navVault.addEventListener('click', function(e){
      e.preventDefault();
      if (isUnlocked()) {
        openVault();
      } else {
        var hero = document.getElementById('mr-top');
        if (hero) hero.scrollIntoView({ behavior: 'smooth' });
        var input = document.getElementById('mce-EMAIL');
        if (input) setTimeout(function(){ input.focus(); }, 600);
      }
    });
  }

  // Subscribe form (Mailchimp JSONP)
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (btn && btn.disabled) return; // no double-submit

      if (btn) { btn.disabled = true; btn.classList.add('loading'); }
      if (msg) msg.style.display = 'none';

      var url = form.action + '&' +
        'EMAIL=' + encodeURIComponent(form.EMAIL.value) + '&' +
        'b_c3701ced379181705d0f74129_2c35058859=';

      var cbName = 'mcCallback_' + Date.now();
      var script;

      function done() {
        if (btn) { btn.disabled = false; btn.classList.remove('loading'); }
        delete window[cbName];
        if (script && script.parentNode) script.parentNode.removeChild(script);
      }

      window[cbName] = function (data) {
        done();
        if (data.result === 'success') {
          form.reset();
          setUnlocked();
          openVault();
        } else {
          var raw = data.msg || 'Something went wrong. Please try again.';
          // "Already subscribed" should still unlock — they're a fan, let them in
          if (/already subscribed|is already a list member/i.test(raw)) {
            setUnlocked();
            openVault();
            return;
          }
          if (msg) {
            msg.style.display = 'block';
            msg.className = 'form-msg form-msg-err';
            var tmp = document.createElement('div');
            tmp.innerHTML = raw;
            msg.textContent = tmp.textContent;
          }
        }
      };

      script = document.createElement('script');
      script.src = url.replace('c=?', 'c=' + cbName);
      script.onerror = function(){
        done();
        if (msg) {
          msg.style.display = 'block';
          msg.className = 'form-msg form-msg-err';
          msg.textContent = 'Connection issue — try again in a second.';
        }
      };
      document.body.appendChild(script);
    });
  }
})();

/* ───────── YT FACADES (load iframe on click) ───────── */
(function(){
  'use strict';
  document.querySelectorAll('.yt-facade').forEach(function(facade){
    facade.addEventListener('click', function(){
      var id = facade.getAttribute('data-yt');
      var title = facade.getAttribute('data-yt-title') || 'Midnight Era video';
      if (!id) return;
      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0&modestbranding=1';
      iframe.title = title;
      iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
      iframe.setAttribute('allowfullscreen', '');
      facade.innerHTML = '';
      facade.classList.remove('yt-facade');
      facade.appendChild(iframe);
    }, { once: true });
  });
})();
